<template>
    <v-dialog max-width="800px" v-model="dialog">
        <v-container style="background-color: white">
            <v-layout wrap v-if="showList">
                <v-flex xs12 sm12 md12 lg12 xl12 style="margin: 5px">
                    <v-data-table :items="students" class="elevation-1 gru-table fixed-header">
                        <template slot="headers">
                            <tr class="yoprimary" style="color:white">
                                <th rowspan="2" width="10%" v-if="selectable">
                                    <input type="checkbox" v-model="checkAll" @change="onChangeCheckAll"/>
                                </th>
                                <th rowspan="2" width="30%">Danh sách học sinh</th>
                                <th colspan="6" width="60%">Phương thức giao bài tập</th>
                            </tr>
                            <tr class="yoprimary" style="color:white">
                                <th width="10%">Trên tường</th>
                                <th width="10%">Email</th>
                                <th width="10%">Yoteacher</th>
                                <th width="10%">Zalo</th>
                                <th width="10%">SMS</th>
                                <th width="10%">Sửa</th>
                            </tr>
                        </template>
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center" v-if="selectable">
                                <!--v-checkbox v-model="item.check"></v-checkbox-->
                                <input type="checkbox" v-model="props.item.check" @change="changeCheck(props.item)"/>
                            </td>
                            <td class="text-xs-left">{{props.item.fullName }}</td>
                            <td class="text-xs-center">
                                <v-icon dark color="orange">check_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-icon v-if="props.item.notifyEmail || props.item.notifyParentEmail" color="orange">check_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-icon v-if="props.item.notifyYolearn ||props.item.notifyParentYolearn" dark color="orange">check_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-icon v-if="props.item.notifyZalo || props.item.notifyParentZalo" color="orange">check_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-icon v-if="props.item.notifySms || props.item.notifyParentSMS" color="orange">check_circle_outline</v-icon>
                            </td>
                            <td>
                                <v-btn fab @click="editMemberNotify(props.item)" icon>
                                    <v-icon>build</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
<!--
                    <table class="lstTable">
                        <tr>
                            <th rowspan="2" width="10%" v-if="selectable">
                                <input type="checkbox" v-model="checkAll" @change="onChangeCheckAll"/>
                            </th>
                            <th rowspan="2" width="30%">Danh sách học sinh</th>
                            <th colspan="6" width="60%">Phương thức giao bài tập</th>
                        </tr>
                        <tr>
                            <th width="10%">Trên tường</th>
                            <th width="10%">Email</th>
                            <th width="10%">Yoteacher</th>
                            <th width="10%">Zalo</th>
                            <th width="10%">SMS</th>
                            <th width="10%">Sửa</th>
                        </tr>
                        <tr v-for="item in students" :key="'row_'+item.userId">
                            <td class="text-xs-center" v-if="selectable">
                                &lt;!&ndash;v-checkbox v-model="item.check"></v-checkbox&ndash;&gt;
                                <input type="checkbox" v-model="item.check" @change="changeCheck(item)"/>
                            </td>
                            <td class="text-xs-left">{{item.fullName }}</td>
                            <td class="text-xs-center">
                                <v-icon v-if="item.notifyWall" dark color="orange">check_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-icon v-if="item.notifyEmail || item.notifyParentEmail" color="orange">check_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-icon v-if="item.notifyYolearn || item.notifyParentYolearn" dark color="orange">check_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-icon v-if="item.notifyZalo || item.notifyParentZalo" color="orange">check_circle_outline</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-icon v-if="item.notifySms || item.notifyParentSMS" color="orange">check_circle_outline</v-icon>
                            </td>
                            <td>
                                <v-btn fab @click="editMemberNotify(item)" icon>
                                    <v-icon>build</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </table>
-->
                    <div style="text-align: right">
                        <v-btn @click="close()" color="cancel">
                            {{$t('lang.common.close')}}
                        </v-btn>
                        <v-btn @click.once="send()" dark class="yoprimary">
                            {{$t('lang.class.send')}}
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout v-else>
                <v-flex>
                    <member-detail :editing-member="editingMember" :user="editingUser" view-type="student" @cancel="showList=true"/>
                </v-flex>
            </v-layout>
        </v-container>
    </v-dialog>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import {CrudService} from "@/services";
    import {Validator, ValidationObserver} from "vee-validate";
    import MemberDetail from "./memberDetail";

    export default {
        name: "send-to-member",

        components: {
            MemberDetail,
            ValidationObserver
        },
        props: {
            classId: {
                type: String | Number,
                default: null
            },

            exerciseId: {
                type: String | Number,
                default: null
            },
            exerciseType: {
                type: String | Number,
                default: null
            },

            userId: {
                type: String | Number,
                default: null
            },

            selectable: {
                type:Boolean,
                default:true
            }
        },

        data: () => ({
            showList: true,
            dialog: false,
            checkAll: false,
            editingMember: null,
            editingUser:null,
            students: [],
        }),

        computed: {},

        watch: {},

        mounted() {
        },

        created() {
        },

        methods: {
            onChangeCheckAll: function () {
                for (let i = 0; i < this.students.length; i++) {
                    this.students[i].check = this.checkAll;
                }
            },

            changeCheck: function (item) {
                if (!item.check) {
                    this.checkAll = false;
                } else {
                    let all = true;
                    for (let i = 0; i < this.students.length; i++) {
                        if (!this.students[i].check) {
                            all = false;
                            break;
                        }
                    }
                    this.checkAll = all;
                }
            },

            filterUser: function(item){
                ////console.log(item);
                ////console.log(this.userId);
                return item.userId == this.userId;
            },

            refreshClassMembers: function () {
                let url = process.env.VUE_APP_API_URL + "/classmember/myStudents?classId=" + this.classId;
                if(this.exerciseId != null){
                    url +="&exerciseId="+this.exerciseId;
                }
                if(this.exerciseType != null){
                    url +="&exerciseType="+this.exerciseType;
                }
                axios
                    .post(url)
                    .then(
                        data => {
                            ////console.log(this.userId);
                            if(this.userId != null){
                                this.students = data.filter(this.filterUser)
                            } else {
                                this.students = data;
                            }
                            this.checkAll = true;
                            for(let i=0;i<this.students.length;i++){
                                this.students[i].check = true;
                            }
                            ////console.log(this.students);
                        },
                        error => {
                        }
                    );
            },

            show: function () {
                this.dialog = true;
                this.refreshClassMembers();
            },

            send: function () {
                let select = [];
                let all = true;
                for (let i = 0; i < this.students.length; i++) {
                    if (this.students[i].check) {
                        select.push(this.students[i].userId);
                    } else {
                        all = false;
                    }
                }
/*
                if (all) {
                    select = [0];
                }
*/
                if (select.length == 0 && this.selectable) {
                    message.error("Bạn chưa chọn học sinh!");
                } else {
                    this.$emit("send", select);
                }
            },

            editMemberNotify: function (member) {
                this.editingMember = member;
                CrudService.of('user').getItem(member.userId).then(user => {
                    this.editingMember = member;
                    this.editingUser = user;
                    this.showList = false;
                });
            },

            close: function () {
                this.dialog = false;
            }
        }
    };
</script>